/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const resetPasswordRequestPasswordMin = 12;

export const ResetPasswordRequest = zod
	.object({
		password: zod.string().min(resetPasswordRequestPasswordMin).describe('New password'),
		password_confirmation: zod.string().describe('Password confirmation')
	})
	.describe('Reset password request body');

export type ResetPasswordRequest = zod.input<typeof ResetPasswordRequest>;
export type ResetPasswordRequestOutput = zod.output<typeof ResetPasswordRequest>;
